<template>
  <div>
    <div v-if="currentFile" class="files-preview-info">
      <ul class="list-group">
        <li class="list-group-item text-break">
          {{ currentFile.fileName }}
        </li>
        <li class="list-group-item">
          <download-file :currentFile="currentFile" :key="JSON.stringify(currentFile)" />
        </li>
      </ul>
    </div>
    <light-box ref="lightbox" :images="lightBoxMedia" :show-light-box="false" />
  </div>
</template>

<script>
import Vue from 'vue';
import LightBox from 'vue-image-lightbox';

const previewSrc = (file) => file.src || file.fileThumbLocation || file.fileLocation || file.url;

export default {
  components: {
    LightBox
  },
  data() {
    return {
      mediaFiles: [],
      currentFileIndex: null
    };
  },
  computed: {
    previewableFiles() {
      return this.mediaFiles.filter((file) => !!previewSrc(file));
    },
    currentFile() {
      return this.previewableFiles[this.currentFileIndex];
    },
    lightBoxMedia() {
      return this.previewableFiles.map((file) => {
        const src = previewSrc(file);
        return { ...file, src, thumb: file.thumb || src };
      });
    }
  },
  mounted() {
    Vue.prototype.$previewFiles = this.previewFiles;
    this.enableWatchLightBoxOn();
    this.enableWatchLightBoxSelect();
  },
  methods: {
    previewFiles(files, index) {
      this.mediaFiles = files;
      const position = this.previewableFiles.indexOf(files[index]);
      if (position === -1) {
        this.mediaFiles = [];
        return;
      }
      this.currentFileIndex = position;
      this.$refs.lightbox.showImage(position);
    },
    enableWatchLightBoxOn() {
      this.$watch(
        () => this.$refs.lightbox.lightBoxOn,
        (state) => {
          if (!state) {
            this.mediaFiles = [];
          }
        }
      );
    },
    enableWatchLightBoxSelect() {
      this.$watch(
        () => this.$refs.lightbox.select,
        (index) => {
          this.currentFileIndex = index;
        }
      );
    }
  }
};
</script>
